module.exports = "/_next/static/images/Folder@2x-08b644c8c9cb33ebe8093807c9fcbf0c.png";